import { Center, Split, Stack } from 'components/layout/primitives'
import { Heading, Paragraph } from 'components/styles'
import { TextMods } from 'components/styles/primitives/modifiers/text/textMods'
import { BlockComponent } from 'lib'
import { Form } from './Form'
import { InstitutionsGrid } from './InstitutionsGrid'
import { ThumbPill } from './CustomPill'
import { ApprovabilityCopy } from '../constants'
import { useApprovabilityControls } from '../store'
import { useRouter } from 'next/router'
import type { ApprovabilityWidgetProps } from '../index'
import { Button } from 'ui/inputs/Button/LegacyButtonCompatibility'
import { AdvertiserDisclosure } from 'components/content'

export const Calculator: BlockComponent<ApprovabilityWidgetProps> = ({ mode }) => {
	const [, { apply }] = useApprovabilityControls()
	const router = useRouter()
	const standalone = mode === 'standalone'
	return (
		<Stack>
			{standalone && <Paragraph>{ApprovabilityCopy.Introduction}</Paragraph>}
			<Split>
				<Heading.H4>Your Details</Heading.H4>
				{standalone && <AdvertiserDisclosure />}
			</Split>
			<Form />
			<Stack>
				<Split>
					<Heading.H4>Your Results</Heading.H4>
					<ThumbPill />
				</Split>
				<InstitutionsGrid />
			</Stack>
			<Center>
				{ApprovabilityCopy.hook.map(text => (
					<Paragraph small key={text.slice(0, 10)} modifiers={TextMods.Centered}>
						{text}
					</Paragraph>
				))}
			</Center>
			<Center>
				<Button onClick={() => apply(router)}>Get Matched</Button>
			</Center>
		</Stack>
	)
}
